import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cookie-banner',
  imports: [CommonModule, FormsModule],
  templateUrl: './cookie-banner.html',
  styleUrl: './cookie-banner.css',
  standalone: true
})
export class CookieBanner implements OnInit {
  public static showBanner = false;
  private readonly COOKIE_NAME = 'cookie-law-accepted';

  constructor(private cookieService: CookieService) {}
  public present() {
    return CookieBanner.showBanner;
  }
  ngOnInit() {
    // Sprawdź czy ciastko już istnieje
    CookieBanner.showBanner = !this.cookieService.check(this.COOKIE_NAME);
  }


  accept() {
    // Ustaw ciastko na 365 dni
    this.cookieService.set(this.COOKIE_NAME, 'true', 365);
    CookieBanner.showBanner = false;
  }
}
